import React from 'react';
import {WrapStyle} from "./styles";
import Button from "shared/Button";

const ButtonRight = (props) => {

    return (
        <WrapStyle data-cy={'button-right'}>
            <Button variant={'secondary'} {...props} icon={'ArrowLeftIcon'}/>
        </WrapStyle>
    );
};

export default ButtonRight;
